import { render, staticRenderFns } from "./ThankYouRedirectView.vue?vue&type=template&id=5367f1b7&scoped=true"
import script from "./ThankYouRedirectView.vue?vue&type=script&lang=js"
export * from "./ThankYouRedirectView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367f1b7",
  null
  
)

export default component.exports